import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import cn from 'classnames';
import "./InlineLink.css";
var styles = { "inlineLink": "fc064d", "inlineLink_meta": "ef7263", "inlineLink_paragraph": "dd3d91", "inlineLink_preamble": "f3e1f9" };
const InlineLink = forwardRef((_a, ref) => {
    var { children, className, token, hasDataTrackingPii, testId } = _a, props = __rest(_a, ["children", "className", "token", "hasDataTrackingPii", "testId"]);
    return (React.createElement("a", Object.assign({ className: cn(styles.inlineLink, className, token && styles[`inlineLink_${token}`]), "data-tracking-pii": hasDataTrackingPii, "data-testid": testId, ref: ref }, props), children));
});
export default InlineLink;
//# sourceMappingURL=InlineLink.js.map